module.exports = __webpack_public_path__ + "img/custom-branding.d8efcdde.svg";